import request from 'api/request';

export const postSubmission = (params, data) =>
  request({
    protectedRoute: true,
    method: 'POST',
    url: `/negociant-data/submission`,
    newApi: true,
    returnFullResponse: true,
    params,
    data
  });
